import { NavigationProp, useNavigation } from "@react-navigation/core";

import { UserLoggedInNavigatorParamList } from "../../../TopLevelNavigators/UserLoggedIn/UserLoggedInNavigatorParamList";
import { WidgetSelectEvent } from "widgets";
import { useEvent } from "../../../common/useEvent";

export const useWidgetEventHandler = ({
  openKPI,
  onNoteEdit,
  onEmployeeRoleSelect,
}: {
  openKPI: (
    routineId: string,
    routineTitle: string,
    sequenceNumber: number,
    sectionIds?: string[]
  ) => void;
  onNoteEdit: (widgetId: string, pageId: string) => void;
  onEmployeeRoleSelect: (data: {
    roleId: string;
    roleName: string;
    teamId: string;
    teamName: string;
    teamColor: string | null;
    employeeIds: string[];
  }) => void;
}) => {
  const navigation =
    useNavigation<NavigationProp<UserLoggedInNavigatorParamList>>();

  const onWidgetPress = useEvent((event: WidgetSelectEvent) => {
    switch (event.kind) {
      case "WidgetEmployeeLeave": {
        break;
      }
      case "WidgetEmployeeSchedule": {
        navigation.navigateDeprecated("EmployeeSchedule", {
          teamIds: event.teamIds,
        });
        break;
      }
      case "TodoCategory": {
        navigation.navigateDeprecated("TodoCategory", {
          id: event.categoryId,
          teamName: event.teamName,
          teamId: event.teamId,
          title: event.categoryTitle,
          fetchKey: new Date().toISOString(),
        });

        break;
      }

      case "FileOpen": {
        navigation.navigateDeprecated("File", {
          id: event.fileId,
          pageId: event.pageId,
        });

        break;
      }
      case "WidgetTaskSingleKPI":
        openKPI(
          event.routineId,
          event.routineTitle,
          event.sequenceNumber,
          event.sectionIds
        );
        break;

      case "WidgetTaskSingle": {
        navigation.navigateDeprecated("RoutineOccasion", {
          routineId: event.routineId,
          sequenceNumber: event.sequenceNumber,
          taskId: event.taskId,
        });

        break;
      }
      case "WidgetTaskCollection": {
        navigation.navigateDeprecated("WidgetTaskCollection", {
          widgetId: event.widgetId,
        });

        break;
      }
      case "WidgetRoutinePositivePercentage": {
        navigation.navigateDeprecated("WidgetRoutinePositivePercentage", {
          widgetId: event.widgetId,
        });
        break;
      }
      case "RoutineOccasion": {
        navigation.navigateDeprecated("RoutineOccasion", {
          sequenceNumber: event.sequenceNumber,
          routineId: event.routineId,
        });
        break;
      }
      case "Todo": {
        navigation.navigateDeprecated("TodoEdit", {
          todoId: event.todoId,
        });

        break;
      }
      case "TodoCreate": {
        navigation.navigateDeprecated("TodoCreate", {
          categoryId: event.categoryId,
          title: event.categoryTitle,
          teamIds: event.teamIds,
        });
        break;
      }

      case "NoteClose": {
        break;
      }
      case "NoteSelect": {
        onNoteEdit(event.widgetId, event.pageId);

        break;
      }
      case "CalendarEvent": {
        navigation.navigate("WidgetCalendarEventEdit", {
          widgetId: event.widgetId,
          eventId: event.eventId,
          connections: event.connections,
        });
        break;
      }
      case "CalendarEventCreate": {
        navigation.navigate("WidgetCalendarEventCreate", {
          widgetId: event.widgetId,
          connections: event.connections,
        });
        break;
      }
      case "TeamScheduleEventItem": {
        break;
      }
      case "Signal": {
        navigation.navigateDeprecated("SignalDetail", {
          signalId: event.signalId,
        });
        break;
      }
      case "EmployeeRoleSelect": {
        onEmployeeRoleSelect({
          roleId: event.roleId,
          roleName: event.roleName,
          teamId: event.teamId,
          teamName: event.teamName,
          teamColor: event.teamColor,
          employeeIds: event.employeeIds,
        });
        break;
      }
    }
  });

  return [onWidgetPress] as const;
};
